import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from '@repo/ui'
import { Link, createFileRoute, redirect, useRouter } from '@tanstack/react-router'
import { CircleAlert } from 'lucide-react'
import { z } from 'zod'
import { apiLogout } from '@/api/user/logout'

export const Route = createFileRoute('/org-mismatch')({
  validateSearch: z.object({
    redirect: z.string().optional().catch(undefined)
  }),
  beforeLoad: ({ context }) => {
    if (!context.user.isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
  head: () => ({ meta: [{ title: 'Invalid URL - Snowvault' }] }),
  component: OrgMismatch
})

function OrgMismatch() {
  const router = useRouter()
  const { redirect: redirectPath } = Route.useSearch()

  async function handleLogout() {
    try {
      await apiLogout()
    } finally {
      router.update({
        context: {
          ...router.options.context,
          user: { isAuthenticated: false }
        }
      })
      const safeRedirect = redirectPath?.startsWith('/') && !redirectPath.startsWith('//') ? redirectPath : undefined
      await router.navigate({ to: '/login', search: { redirect: safeRedirect } })
    }
  }

  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-md">
        <Card>
          <CardHeader className="items-center text-center">
            <CircleAlert className="mb-2 h-12 w-12 text-warning" />
            <CardTitle>Invalid URL</CardTitle>
            <CardDescription>
              The URL provided is not valid for the user you&apos;re currently logged in as. Would you like to log out
              and back in?
            </CardDescription>
          </CardHeader>
          <CardContent className="flex justify-center gap-2">
            <Button variant="outline" asChild>
              <Link to="/">Go to my organisation</Link>
            </Button>
            <Button onClick={handleLogout}>Login with different user</Button>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
